<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '800px' }"
  [header]="'IMPORT_DATA' | translate"
  (onHide)="closeImportModal()">

  <app-file-upload
    title="{{'File upload' | translate}} (GeoJSON, KML, Shapefile)"
    [multiple]="true"
    [accept]="'.geojson, .kml, .shp,'"
    (filesSelected)="onFileSelected($event)"
    (fileRemoved)="onFileRemoved($event)">
  </app-file-upload>



  <div class="field-group   mt-4 align-items-start flex flex-column">
    <label>{{ 'Comment' | translate }}</label>
    <app-textarea
      class="mt-2"
      placeholder="{{ 'Fields comment' | translate }}"
      [(ngModel)]="formData.comment"
    ></app-textarea>
  </div>

  <div class="import-actions flex  flex-row-reverse gap-2 mt-2">
    <app-secondary-button
      [title]="'CANCEL'"
      (action)="closeImportModal()"
    ></app-secondary-button>

    <app-primary-button
      [title]="'IMPORT'"
      [loading]="isImporting"
      [disable]="(!selectedImportFiles || selectedImportFiles.length === 0) || isImporting"
      (action)="performImport()"
    ></app-primary-button>
  </div>

</p-dialog>
